module.exports = __webpack_public_path__ + "img/pizza.b1ec4822.png";